/**
 * Membuka tautan yang baru didapat dari server di tab baru.
 *
 * Tab harus dibuka saat klik masih berlangsung. Bila baru dibuka setelah menunggu
 * jawaban server, peramban memblokirnya sebagai pop-up.
 */
export async function bukaTautan(ambilUrl) {
  const tab = window.open('about:blank', '_blank')
  try {
    const url = await ambilUrl()
    if (!tab) {
      window.location.assign(url)
      return
    }
    tab.opener = null
    tab.location.href = url
  } catch (err) {
    tab?.close()
    throw err
  }
}
